import { useTranslation } from 'react-i18next';
import Kicker from './Kicker';
import SectionShell from './SectionShell';

function ProblemSection() {
  const { t } = useTranslation();

  const problemCards = [
    { number: '01.', title: t('problem.cards.c1_title'), copy: t('problem.cards.c1_copy') },
    { number: '02.', title: t('problem.cards.c2_title'), copy: t('problem.cards.c2_copy') },
    { number: '03.', title: t('problem.cards.c3_title'), copy: t('problem.cards.c3_copy'), dark: true },
  ];

  return (
    <SectionShell id="problem">
      <div>
        <Kicker>{t('problem.kicker')}</Kicker>
        <div className="grid gap-8 lg:grid-cols-[0.8fr_1.2fr] lg:items-end">
          <h2 className="text-4xl font-black leading-tight sm:text-5xl">{t('problem.title')}</h2>
          <p className="text-lg leading-8 text-slate-600">{t('problem.body')}</p>
        </div>

        <div className="mt-10 grid gap-5 lg:grid-cols-3">
          {problemCards.map((card) => (
            <article
              key={card.number}
              className={`rounded border p-7 ${
                card.dark ? 'border-[#070b14] bg-[rgb(16_185_129)] text-white' : 'border-slate-200 bg-white'
              }`}
            >
              <p className="text-sm font-extrabold uppercase text-emerald-500">{card.number}</p>
              <h3 className="mt-5 text-2xl font-black">{card.title}</h3>
              <p className={`mt-6 text-base leading-7 ${card.dark ? 'text-slate-100' : 'text-slate-600'}`}>
                {card.copy}
              </p>
            </article>
          ))}
        </div>
      </div>
    </SectionShell>
  );
}

export default ProblemSection;

